<template>
  <div class="panel mt-20">
    <div class="header flex-row-between">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="startCustomerContactFormer()"
        v-if="hasAuth('customerContactorNew') || hasAuth('serverQuestComent')"
        >添加联系人</el-button
      >
    </div>
    <el-table v-if="!isMobile()" :data="contacts" stripe key="contacts">
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column
        prop="mobile"
        label="电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="duty"
        label="职务"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="email"
        label="邮箱"
        align="center"
      ></el-table-column>
      <el-table-column label="来源" align="center" v-if="!serviceQuestID">
        <template slot-scope="scope">
          {{ scope.row.customer_user_id ? '小程序注册' : '系统创建' }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="260"
        align="center"
        v-if="!customerDeleted"
      >
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            plain
            @click="deleteContact(scope.$index)"
            v-permission="Auth.customerContactorDelete"
            >删除</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            @click="startCustomerContactFormer(scope.row, scope.$index)"
            v-permission="Auth.customerContactorEdit"
            >修改</el-button
          >
          <el-popconfirm
            class="ml-10"
            title="确定向该客户发送服务评价短信吗？"
            v-if="serviceQuestID"
            @confirm="sendCommentMgs(scope.row)"
            v-permission="Auth.customerContactorComment"
          >
            <el-button slot="reference" type="primary" plain size="mini"
              >发送评价短信</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="(item, index) in contacts" :key="item.id">
        <div>
          <div>
            {{ item.name }}
            <span v-if="item.duty && item.duty.length > 0"
              >({{ item.duty }})</span
            >
          </div>
          <div
            style="margin-top: 5px"
            v-if="item.mobile && item.mobile.length > 0"
          >
            <a :href="'tel:' + item.mobile">{{ item.mobile }}</a>
          </div>
          <div v-if="item.email && item.email.length > 0">
            <a :href="'mailto:' + item.email">{{ item.email }}</a>
          </div>
        </div>
        <div v-if="!customerDeleted" class="mt-10">
          <el-button
            type="danger"
            size="mini"
            plain
            @click="deleteContact(index)"
            v-permission="Auth.customerContactorDelete"
            >删除</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            @click="startCustomerContactFormer(item, index)"
            v-permission="Auth.customerContactorEdit"
            >修改</el-button
          >
          <el-popconfirm
            class="ml-10"
            title="确定向该客户发送服务评价短信吗？"
            v-if="serviceQuestID"
            @confirm="sendCommentMgs(item)"
            v-permission="Auth.customerContactorComment"
          >
            <el-button slot="reference" type="primary" plain size="mini"
              >发送评价短信</el-button
            >
          </el-popconfirm>
        </div>
      </li>
      <p v-if="contacts.length == 0" class="mt-20">暂无数据</p>
    </ul>
    <customer-contact-former
      :model="customerContactForm"
      :show.sync="createCustomerContactFormVisible"
      :inner="serviceQuestID > 0"
      @created="createdCustomerContact"
      @updated="updatedCustomerContact"
    ></customer-contact-former>
  </div>
</template>

<script>
import {
  creatCustomerContact,
  customerContactList,
  deleteCustomerContact,
  serviceQuestSendCommentMsg,
} from '../../service/getData'
import CustomerContactFormer from '@/components/customer_contact'
import { formatTime, isMobile } from '@/util/index'

import { clone } from '@/util'
import { hasAuth } from '@/permission'

export default {
  props: {
    customerID: {
      type: Number,
    },
    customerDeleted: {
      type: Number,
      default: 0,
    },
    serviceQuestID: {
      type: Number,
      default: 0,
    },
  },
  components: { CustomerContactFormer },
  data() {
    return {
      hasAuth,
      isMobile,
      contacts: [],
      customerContactForm: {},
      editContactIndex: 0,
      createCustomerContactFormVisible: false,
    }
  },
  watch: {
    customerID: function () {
      if (this.serviceQuestID && this.customerID) {
        this.requestCustomerContactList()
      }
    },
  },
  created() {
    this.requestCustomerContactList()
  },
  methods: {
    startCustomerContactFormer(contact, index) {
      if (contact) {
        this.customerContactForm = clone(contact)
        this.editContactIndex = index
      } else {
        this.customerContactForm = {
          customer_id: this.customerID,
          name: '',
          duty: '',
          mobile: '',
          email: '',
        }
      }
      this.createCustomerContactFormVisible = true
    },
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
      })
      this.contacts = res.data.list
    },
    updatedCustomerContact(contact) {
      this.contacts.splice(this.editContactIndex, 1, contact)
    },
    createdCustomerContact(contact) {
      this.contacts.unshift(contact)
    },
    deleteContact(index) {
      let c = this.contacts[index]
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteCustomerContact(c.id).then((res) => {
          if (res.code == 0) {
            that.contacts.splice(index, 1)
          }
        })
      })
    },

    async sendCommentMgs(item) {
      let res = await serviceQuestSendCommentMsg({
        service_quest_id: this.serviceQuestID,
        customer_contact_id: item.id,
        customer_id: this.customerID,
      })

      if (res.code == 0) {
        this.$alert('发送成功！')
      }
    },
  },
}
</script>